import { NavigationItem } from 'features/brandbook/types';
import React from 'react';


interface OnThisPageProps {
  activeSection: string;
  onSectionClick: (sectionId: string) => void;
}

const OnThisPage: React.FC<OnThisPageProps> = ({
  activeSection,
  onSectionClick,
}) => {
  const navigationItems: NavigationItem[] = [
    { label: 'Brand name', id: 'brand-name' },
    { label: 'Slogan', id: 'slogan' },
    { label: 'Brand values', id: 'brand-values' },
    { label: 'Vision', id: 'vision' },
    { label: 'Voice', id: 'voice' },
    { label: 'Product/Service', id: 'product-service' },
    { label: 'Logo', id: 'logo' },
    { label: 'Color Palette', id: 'color-palette' },
  ];

  return (
    <>
      {/* Mobile version - Horizontal Scrollable Bar with underline indicator */}
      <div className="lg:hidden bg-background-main border-b">
        <div className="scrollbar-hide overflow-x-auto">
          <div className="flex space-x-6 px-4 py-2 min-w-max">
            {navigationItems.map((item) => (
              <button
                key={item.id}
                onClick={() => onSectionClick(item.id)}
                className={`py-2 text-sm whitespace-nowrap transition-colors relative
                  ${
                    activeSection === item.id
                      ? 'text-primary'
                      : 'text-text-secondary hover:text-primary'
                  }`}
              >
                {item.label}
                {activeSection === item.id && (
                  <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-primary transition-all duration-300" />
                )}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Desktop version - Sidebar */}
      <div className="hidden lg:block bg-background-main text-text-primary rounded-lg">
        <div>
          <h2 className="text-center mb-8">ON THIS PAGE</h2>
          <div className="relative">
            <div className="absolute left-0 top-0 bottom-0 w-0.5 bg-secondary" />
            <nav className="relative">
              {navigationItems.map((item) => (
                <div key={item.id} className="relative group">
                  <div
                    className={`absolute left-0 top-0 bottom-0 w-0.5 ${
                      activeSection === item.id
                        ? 'bg-primary'
                        : 'group-hover:bg-primary'
                    }`}
                  />
                  <div
                    onClick={() => onSectionClick(item.id)}
                    className={`pl-6 py-2 cursor-pointer transition-colors ${
                      activeSection === item.id
                        ? 'text-primary font-medium'
                        : 'hover:text-primary'
                    }`}
                  >
                    {item.label}
                  </div>
                </div>
              ))}
            </nav>
          </div>
        </div>
      </div>
    </>
  );
};

export default OnThisPage;